export const HUBSPOT_FLOATING_STACK_BASE =
  'dash-transition-md !fixed !bottom-4 !flex !flex-col !gap-3 print:!hidden';

export const HUBSPOT_STACK_RIGHT = {
  nonChatPanelOpen: 'right-[23rem]',
  default: '!right-4',
} as const;

export function getHubspotStackRightClass(nonChatSidePanelOpen: boolean): string {
  return nonChatSidePanelOpen ? HUBSPOT_STACK_RIGHT.nonChatPanelOpen : HUBSPOT_STACK_RIGHT.default;
}

export const VISION_FAB_RIGHT = {
  whenNonChatSidePanelOpen: {
    ready: '!right-[24.75rem]',
    hubspotNotReady: '!right-[22rem]',
  },
  whenDefault: {
    ready: '!right-[2.75rem]',
    hubspotNotReady: '!right-0',
  },
} as const;

export type VisionFabRightState = {
  nonChatSidePanelOpen: boolean;
  hubspotReady: boolean;
};

export function getVisionFabRightClass(state: VisionFabRightState): string {
  const variant = state.hubspotReady ? 'ready' : 'hubspotNotReady';
  const branch = state.nonChatSidePanelOpen ? 'whenNonChatSidePanelOpen' : 'whenDefault';
  return VISION_FAB_RIGHT[branch][variant];
}
